import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../auth/hooks/useAuth";

export const SuperAdminGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  console.log("SuperAdminGuard - Current Location:", location.pathname);
  console.log("SuperAdminGuard - Auth State:", {
    user,
    isAuthenticated,
    loading,
    userRole: user?.role,
    userDetails: user ? { ...user } : null,
  });

  // Show loading state
  if (loading) {
    console.log("SuperAdminGuard - Still loading auth state");
    return <div>Loading...</div>;
  }

  // Check authentication first
  if (!isAuthenticated || !user) {
    console.log("SuperAdminGuard - Not authenticated:", {
      isAuthenticated,
      hasUser: !!user,
    });
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Check user role
  if (user.role !== "SUPER_ADMIN") {
    console.log("SuperAdminGuard - Invalid role:", {
      currentRole: user.role,
      requiredRole: "SUPER_ADMIN",
    });
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  console.log("SuperAdminGuard - Access granted to super admin");
  return <>{children}</>;
};
